import script from "./addWhiteListModel.vue?vue&type=script&setup=true&lang=jsx"
export * from "./addWhiteListModel.vue?vue&type=script&setup=true&lang=jsx"

import "./addWhiteListModel.vue?vue&type=style&index=0&id=b054aa70&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b054aa70"]])

export default __exports__